import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="room-card-click-handler"
export default class extends Controller {
  
  static targets = ['button']
  
  buttonClick() {
    this.buttonTarget.click();
  }
  
}